import { Component, HostListener, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { DatosPlataforma } from './shared/cons/common';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from './shared/helpers/decorators/AutoUnsubscribe';
import { MatSnackBar } from '@angular/material/snack-bar';

@AutoUnsubscribe
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title:string =  DatosPlataforma.NOMBRE_PLATAFORMA;
  swUpdateSb!:Subscription;

  constructor(
    private swUpdate: SwUpdate,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.listenToAvailableUpdates();
    this.checkForUpdates();
    

    // Verificar actualizaciones cada 12 horas
    setInterval(() => {
      this.checkForUpdates();
    }, 12 * 60 * 60 * 1000); // 12 horas
  }

@HostListener('document:visibilitychange', [])
onVisibilityChange(): void {
  if (document.visibilityState === 'visible') {
    console.log('[PWA] La pestaña volvió a ser visible');
    this.checkForUpdates();
  }
}

 private checkForUpdates(): void {
  if (this.swUpdate.isEnabled) {
    // Verifica si hay una nueva versión disponible
    this.swUpdate.checkForUpdate().then(hasUpdate => {
      console.log('¿Hay actualización disponible?', hasUpdate);

      // Lee el ngsw.json para obtener el hash actual
      fetch('/ngsw.json')
        .then(res => res.json())
        .then(data => {
          console.log('La Versión actual (hash):', data.configVersion);
        })
        .catch(err => {
          console.warn('No se pudo leer ngsw.json:', err);
        });
    }).catch(err => {
      console.error('Error al buscar actualizaciones:', err);
    });
  }
}


  private listenToAvailableUpdates(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe((event) => {
          console.log('Versión anterior:', event.current.hash);
          console.log('Nueva versión disponible:', event.available.hash);
        this.promptUser();
      });
    }
  }

  private promptUser(): void {
    const snack = this.snackBar.open('¡Nueva versión disponible!', 'Actualizar', {
      duration: 10000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['custom-snackbar']
    });

    snack.onAction().subscribe(() => {
      window.location.reload();
    });
  }
}
 